const urlConfig = {
  'www.pronto.com': {
    pathname: '/shopping',
  },
  'www.informationvine.com': {
    pathname: '/index',
  },
  default: {
    pathname: '/web',
  },
};

export default urlConfig;
